/**
 * These settings are always settings per user basis.
 */

import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        read(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/settings/user-id/6", { params: queryParams })
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
    },
};
